import { render, staticRenderFns } from "./listCompany.vue?vue&type=template&id=10e7f95c&scoped=true&"
import script from "./listCompany.vue?vue&type=script&lang=js&"
export * from "./listCompany.vue?vue&type=script&lang=js&"
import style0 from "./listCompany.vue?vue&type=style&index=0&id=10e7f95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e7f95c",
  null
  
)

export default component.exports